'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.26863 6.75612C3.94562 6.45468 3.92813 5.94845 4.22957 5.62543L7.19552 2.44723C7.63778 1.97332 8.38898 1.97332 8.83125 2.44723L11.7719 5.59827C12.0734 5.92129 12.0559 6.42752 11.7329 6.72897C11.4098 7.03042 10.9036 7.01294 10.6022 6.68992L8.79893 4.75768L8.79893 10.5594C8.79893 11.0013 8.44076 11.3594 7.99893 11.3594C7.5571 11.3594 7.19893 11.0013 7.19893 10.5594V4.78868L5.39933 6.71706C5.09788 7.04008 4.59165 7.05757 4.26863 6.75612ZM2.70884 9.75386C2.70884 9.31203 2.35067 8.95386 1.90884 8.95386C1.46702 8.95386 1.10884 9.31203 1.10884 9.75386V10.3145L1.10884 10.371V10.371C1.10881 11.4543 1.10879 12.3476 1.20385 13.0546C1.30364 13.7969 1.52122 14.4524 2.04611 14.9773C2.57101 15.5022 3.22655 15.7198 3.96883 15.8196C4.67585 15.9147 5.56915 15.9146 6.65247 15.9146L6.70893 15.9146H9.29624L9.3527 15.9146C10.436 15.9146 11.3293 15.9147 12.0363 15.8196C12.7786 15.7198 13.4342 15.5022 13.9591 14.9773C14.4839 14.4524 14.7015 13.7969 14.8013 13.0546C14.8964 12.3476 14.8964 11.4543 14.8963 10.371V10.371L14.8963 10.3145V9.7898C14.8963 9.34797 14.5382 8.9898 14.0963 8.9898C13.6545 8.9898 13.2963 9.34797 13.2963 9.7898V10.3145C13.2963 11.4685 13.2946 12.2536 13.2156 12.8414C13.1396 13.4063 13.0057 13.6679 12.8277 13.846C12.6496 14.024 12.388 14.1579 11.8231 14.2339C11.2353 14.3129 10.4502 14.3146 9.29624 14.3146H6.70893C5.55492 14.3146 4.76989 14.3129 4.18203 14.2339C3.61717 14.1579 3.35555 14.024 3.17748 13.846C2.99942 13.6679 2.86552 13.4063 2.78958 12.8414C2.71054 12.2536 2.70884 11.4685 2.70884 10.3145V9.75386Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
